module.exports = __webpack_public_path__ + "static/media/Reset Blue.44212145.svg";